// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  Destination,
} from "./types";


export default __t.row({
  id: __t.u8().primaryKey(),
  adminPublicKeyHash: __t.u256().name("admin_public_key_hash"),
  feeAccountPublicKeyHash: __t.u256().name("fee_account_public_key_hash"),
  get feeEvacuationDestination() {
    return Destination.name("fee_evacuation_destination");
  },
});
